var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.css()},[_c('AtomText',{attrs:{"color":_vm.AtomTextColorEnum.RAINY}},[_vm._v(" "+_vm._s(_vm.t("module.inbox.no_conversation_selected_message"))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }